import {
  broadBandLinks,
  cloudVoiceLinks,
  commonLinks,
  FIRST_COLUMN_LINKS,
} from './constants';

export const sortById = (linkInfoA: components.HelpSectionLink, linkInfoB: components.HelpSectionLink): number =>
  linkInfoA.id > linkInfoB.id ? 1 : -1;

export const getLinks = (
  isCloudVoice: boolean,
  isBroadband: boolean,
  columnNumber: string,
): Array<components.HelpSectionLink> => {
  const broadband = broadBandLinks[columnNumber];
  const cloudVoice = cloudVoiceLinks[columnNumber];
  let defaultFirstColumnItems: Array<components.HelpSectionLink> = [];

  if (columnNumber === FIRST_COLUMN_LINKS) {
    defaultFirstColumnItems = commonLinks;
  }

  if (isCloudVoice && isBroadband) {
    return broadband.concat(cloudVoice, defaultFirstColumnItems).sort(sortById);
  }

  if (isCloudVoice) {
    return cloudVoice.concat(defaultFirstColumnItems).sort(sortById);
  }

  return broadband.concat(defaultFirstColumnItems).sort(sortById);
};
